export default __webpack_public_path__ + "media/projects/red2-thumb-7b3dd8ae.svg";